import { trackerEvaluationApi } from "@/core/apis";

// getter types
export const TRACKER_EVALUATIONS = "trackerEvaluations";

// action types
export const GET_TRACKER_EVALUATIONS = "getTrackerEvaluations";

// mutation types
const SET_TRACKER_EVALUATIONS = "setTrackerEvaluations";

const state = {
  trackerEvaluations: []
};

const getters = {
  [TRACKER_EVALUATIONS](state) {
    return state.trackerEvaluations;
  }
};

const actions = {
  [GET_TRACKER_EVALUATIONS](context) {
    return new Promise(resolve => {
      trackerEvaluationApi.getAllTrackerTests().then(response => {
        context.commit(SET_TRACKER_EVALUATIONS, response);

        resolve();
      });
    });
  }
};

const mutations = {
  [SET_TRACKER_EVALUATIONS](state, trackerEvaluations) {
    state.trackerEvaluations = trackerEvaluations;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
